import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DealService } from "../../services";
import { InsuranceProduct, TermCost } from "../../models";
import { HistoryService } from "../../services/history.service";

@Component({
  selector: "app-insurance-item-ewu",
  templateUrl: "./insurance-item-ewu.component.html",
  styleUrls: ["./insurance-item-ewu.component.scss"]
})
export class InsuranceItemEwuComponent implements OnInit {
  @Input() product: InsuranceProduct;
  @Input() selectedTermIndex = null;
  @Output() closeModal = new EventEmitter();
  private uiState = {
    activeView: "damages",
    tabs: [
      {title: "Sample Damages", id: "damages"},
      {title: "Coverage", id: "coverage"},
      {title: "Overview", id: "overview"}
    ]
  };

  ewuForm: UntypedFormGroup = this.formBuilder.group({
    termCostIndex: [0]
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dealService: DealService,
    private historyService: HistoryService,
  ) { }

  ngOnInit() {
    this.syncSelectedPlan();
    this.ewuForm.valueChanges.subscribe(({termCostIndex}) => {
      this.dealService.dealInsuranceService.submitInsuranceProduct(this.product, +termCostIndex, true);
    });
  }

  // INITIALIZATION

  syncSelectedPlan() {
    const termCostIndex = this.selectedTermIndex || 0;
    this.ewuForm.patchValue({termCostIndex});
  }

  // ACTIONS

  onAcceptPlan() {
    const {termCostIndex} = this.ewuForm.value;
    this.historyService.dispatchAddEvent({
      shortName: "EWU Plan Accepted",
    })
    this.dealService.dealInsuranceService.submitInsuranceProduct(this.product, +termCostIndex);
    this.closeModal.emit();
  }

  onDeclinePlan() {
    this.historyService.dispatchAddEvent({
      shortName: "EWU Plan Declined",
    })
    this.dealService.dealInsuranceService.removeInsuranceProduct(this.product);
    this.closeModal.emit();
  }

  // UI CONTROL & RENDERING

  onSelectView(type: string) {
    this.uiState.activeView = type;
  }

  activeView(type: string): boolean {
    return this.uiState.activeView === type;
  }

  get viewTabs() {
    return this.uiState.tabs;
  }

  get termCosts(): TermCost[] {
    const terms = this.product ? this.product.termCosts : false;
    return terms || [];
  }

  planSelected(): boolean {
    const {termCostIndex} = this.ewuForm.value;
    return this.selectedTermIndex === +termCostIndex;
  }

  noPlanSelected(): boolean {
    return this.selectedTermIndex === null;
  }

}
